/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createRoutineOverrideBodyStartOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const createRoutineOverrideBodyEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const createRoutineOverrideBodySubstituteUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createRoutineOverrideBodyReasonMax = 1000;

export const createRoutineOverrideBodyExpectedVersionExclusiveMin = 0;
export const createRoutineOverrideBodyExpectedVersionMax = 9007199254740991;

export const CreateRoutineOverrideBody = zod.object({
  start: zod.union([
    zod.iso.datetime({ offset: true }).regex(createRoutineOverrideBodyStartOneRegExp),
    zod.literal('now'),
  ]),
  end: zod.iso.datetime({ offset: true }).regex(createRoutineOverrideBodyEndRegExp),
  substituteUserId: zod.uuid().regex(createRoutineOverrideBodySubstituteUserIdRegExp),
  reason: zod.string().max(createRoutineOverrideBodyReasonMax).optional(),
  expectedVersion: zod
    .int()
    .gt(createRoutineOverrideBodyExpectedVersionExclusiveMin)
    .max(createRoutineOverrideBodyExpectedVersionMax),
});

export type CreateRoutineOverrideBody = zod.input<typeof CreateRoutineOverrideBody>;
export type CreateRoutineOverrideBodyOutput = zod.output<typeof CreateRoutineOverrideBody>;
